import React, { useState, useEffect } from 'react';
import { CheckToken } from '../login/AccessToken';
import axios from 'axios';
import './BillingPayment.scss';
import './StagingArea.scss';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';

const StagingArea = ({ pathname }) => {
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState('');
  const [aabhaId, setAabhaId] = useState('');




  const [selectedPatientId, setSelectedPatientId] = useState('');
  const [patientList, setPatientList] = useState([]);
  const [careContexts, setCareContexts] = useState([]);
  const [selectedCareContext, setSelectedCareContext] = useState('');
  const [fhirData, setFhirData] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState('');
  const [facilityList, setFacilityList] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [medicinesList, setMedicinesList] = useState([]);
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const handleDoctorCheckboxChange = (doctorName) => {
    if (selectedDoctors.includes(doctorName)) {
      setSelectedDoctors(selectedDoctors.filter((name) => name !== doctorName));
    } else {
      setSelectedDoctors([...selectedDoctors, doctorName]);
    }
  };

  // const handleServiceRequestCheckboxChange = (serviceRequestId) => {
  //   if (selectedServiceRequests.includes(serviceRequestId)) {
  //     setSelectedServiceRequests(selectedServiceRequests.filter((id) => id !== serviceRequestId));
  //   } else {
  //     setSelectedServiceRequests([...selectedServiceRequests, serviceRequestId]);
  //   }
  // };
  const handleServiceRequestCheckboxChange = (serviceRequestCode) => {
    if (selectedServiceRequests.includes(serviceRequestCode)) {
      setSelectedServiceRequests(selectedServiceRequests.filter((lab_test_id) => lab_test_id !== serviceRequestCode));
    } else {
      setSelectedServiceRequests([...selectedServiceRequests, serviceRequestCode]);
    }
  };
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);


  useEffect(() => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem('accessToken') ?? '');
  }, []);

  useEffect(() => {
    fetchFacilityListFromClient();
  }, [authToken]);

  useEffect(() => {
    if (selectedFacility) {
      fetchPatientList();
      // fetchMedicines()
    }
  }, [selectedFacility]);

  // useEffect(() => {
  //   if (aabhaId) {
  //     fetchCareContexts();
  //   }
  // }, [aabhaId]);

  // useEffect(() => {
  //   if (selectedCareContext) {
  //     fetchFhirData();
  //   }
  // }, [selectedCareContext]);
  console.log("serviceRequests", serviceRequests)
  const fetchFacilityListFromClient = () => {
    if (authToken !== "") {
      axios.post(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facility_list_from_client/`, null, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
        .then((res) => {
          setFacilityList(res.data.facility_list);
        })
        .catch((error) => {
          console.error('Error fetching facility list from client:', error);
        });
    }
  };

  // const fetchPatientList = () => {
  //    // Prepare the data for the conversion to an invoice with payment
  //    const requestData = {
  //     facility_id: selectedFacility
  //   };
  //   if (authToken !== "" && selectedFacility !== "") {
  //     axios.post(`${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_based_on_selected_facility/`, {
  //       headers: { Authorization: `Bearer ${authToken}` },requestData

  //     })
  //       .then((res) => {
  //         setPatientList(res.data);
  //       })
  //       .catch((error) => {
  //         console.error('Error fetching patient list:', error);
  //       });
  //   }
  // };

  const fetchPatientList = () => {

    const requestData = {
      facility_id: selectedFacility
    };
    if (authToken !== "" && selectedFacility !== "") {
      axios.post(`${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_based_on_selected_facility/`, requestData, {
        headers: headers
      })
        .then((res) => {
          setPatientList(res.data.patient_list);
        })
        .catch((error) => {
          console.error('Error fetching patient list:', error);
        });
    }
  };

  function fetchLabTests(patientId) {
    const requestData = {
      patient_id: patientId
    };
    axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}get_specific_patient_lab_tests/`, requestData,
      { headers: headers }
    )
      .then((response) => {

        setLabTests(response.data.lab_test_list);
      })
      .catch((error) => {
        console.log('FETCH FAILED:', error);
      });
  }
  function fetchMedicines(patientId) {
    const requestData = {
      patient_id: patientId
    };
    axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}get_specific_patient_medicines/`, requestData,
      { headers: headers }
    )
      .then((response) => {

        setMedicinesList(response.data.medicine_list);
      })
      .catch((error) => {
        console.log('FETCH FAILED:', error);
      });
  }



  // const handlePatientSelectChange = (e) => {
  //   const selectedPatientId = e.target.value;
  //   const selectedPatient = patientList.find(patient => patient.patient_id === selectedPatientId);
  //   const selectedAabhaId = selectedPatient ? selectedPatient.abha_id : '';

  //   const selectedSnomedCode=selectedPatient ? selectedPatient.snomed_code: '';
  //   const selectedLabTestId=selectedPatient ? selectedPatient.lab_test_id: '';
  //   setLabTestId(selectedLabTestId)
  //   setSnomedCode(selectedSnomedCode )

  //   const selectedLabTests = labTests.filter(test => selectedServiceRequests.includes(test.lab_test_id));


  // const snomedCodes = selectedLabTests.map(test => test.snomed_code);
  // const labTestIds = selectedLabTests.map(test => test.lab_test_id);

  // console.log('Selected SNOMED codes:', snomedCodes);
  // console.log('Selected Lab Test IDs:', labTestIds);
  //   setSelectedPatientId(selectedPatientId);
  //   setAabhaId(selectedAabhaId);
  //   fetchLabTests(selectedPatientId);
  // };
  const handlePatientSelectChange = (e) => {
    const selectedPatientId = e.target.value;
    const selectedPatient = patientList.find(patient => patient.patient_id === selectedPatientId);
    const selectedAabhaId = selectedPatient ? selectedPatient.abha_id : '';

    setSelectedPatientId(selectedPatientId);
    setAabhaId(selectedAabhaId);
    fetchLabTests(selectedPatientId);
    fetchMedicines(selectedPatientId);
  };






  // const handleAddToInvoice = () => {

  //   console.log("Adding selected items to the invoice:", selectedDoctors, selectedServiceRequests, "aabhaId:", aabhaId);
  //   console.log('Selected SNOMED code:', snomedCode );
  // console.log('Selected Lab Test ID:', labTestId);
  //   // history.push({
  //   //   pathname: `/newEstimate`,
  //   //   state: {
  //   //     selectedDoctors,
  //   //     selectedServiceRequests,
  //   //   },
  //   // });
  //   const newPathname = pathname || '/newEstimate';

  //   history.push({
  //     pathname: newPathname,
  //     state: {
  //       selectedDoctors,
  //       selectedServiceRequests,
  //       aabhaId,
  //       snomedCode,

  //     source: 'populated'
  //     },
  //   });

  // };
  const handleAddToInvoice = () => {
    // Extracting SNOMED codes from selected lab tests

    const selectedLabTestsPair = labTests
      .filter(test => selectedServiceRequests.includes(test.test_name))
      .map(test => ({
        test_name: test.test_name,
        snomed_code: test.snomed_code
      }));
    console.log("selectedLabTestsPair", selectedLabTestsPair)

    const selectedLabTests = labTests.filter(test => selectedServiceRequests.includes(test.lab_test_id));
    const snomedCodes = selectedLabTests.map(test => test.snomed_code);

    // Adding selected items along with SNOMED codes to the invoice
    console.log("Adding selected items to the invoice:", selectedDoctors, selectedServiceRequests, "aabhaId:", aabhaId);
    console.log('Selected SNOMED codes:', snomedCodes);

    const newPathname = pathname || '/newEstimate';

    history.push({
      pathname: newPathname,
      state: {
        selectedDoctors,
        selectedServiceRequests,
        aabhaId,
        snomedCodes,
        source: 'populated',
        selectedLabTestsPair

      },
    });
  };

  const buttonText = pathname && pathname.includes("/newInvoice") ? "Add to Invoice" : "Add to Estimate";

  return (
    <div className="staging-area">
      <div className="col-sm-12 col-md-12 col-lg-7" style={{ maxWidth: "95%" }}>
        <h1 style={{ textAlign: "center" }}>Staging Area</h1>
        <div className="contact-panel mb-50" style={{ boxShadow: "none" }}>
          <form className="contact-panel__form" >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="facilitySelect">Select Facility:</label>
                  <select
                    className="form-control"
                    id="facilitySelect"
                    name="facilitySelect"
                    value={selectedFacility}
                    onChange={(e) => setSelectedFacility(e.target.value)}
                  >
                    <option value="">Select a facility</option>
                    {facilityList.map((facility) => (
                      <option key={facility.facility_id} value={facility.facility_id}>
                        {`${facility.facility_id} - ${facility.facility_name}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="patientSelect">Select Patient:</label>
                  <select
                    className="form-control"
                    id="patientSelect"
                    name="patientSelect"
                    value={selectedPatientId}
                    onChange={handlePatientSelectChange}
                  >
                    <option value="">Select a patient</option>
                    {patientList.map((patient) => (
                      <option key={patient.patient_id} value={patient.patient_id}>
                        {`${patient.patient_id} - ${patient.name} -${patient.age} Yr`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

            </div>
          </form>
          <h5>Tests And Examinations to be Included:</h5>
          {/* <div className="contact-panel mb-50">

            {labTests.map((serviceRequest) => (
              <div key={serviceRequest.lab_test_id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={serviceRequest.lab_test_id}
                  checked={selectedServiceRequests.includes(serviceRequest.lab_test_id)}
                  onChange={() => handleServiceRequestCheckboxChange(serviceRequest.lab_test_id)}
                />
                <label>{` ${serviceRequest.test_name}- ${serviceRequest.appointment_start_time}`}</label>
              </div>
            ))}
          </div> */}
          <div className="contact-panel mb-30 scrollable-container">
            {labTests.map((serviceRequest) => (
              <div key={serviceRequest.lab_test_id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={serviceRequest.lab_test_id}
                  checked={selectedServiceRequests.includes(serviceRequest.lab_test_id)}
                  onChange={() => handleServiceRequestCheckboxChange(serviceRequest.lab_test_id)}
                />
                <label>{` ${serviceRequest.test_name}- ${new Date(serviceRequest.appointment_start_time).toLocaleString()}`}</label>
              </div>
            ))}
          </div>
          {/* <h5>Medicines to be Included:</h5>
          <div className="contact-panel mb-50 scrollable-container">
            {medicinesList.map((medicine) => (
              <div key={medicine.snomed_code}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={medicine.snomed_code}
                  checked={selectedServiceRequests.includes(medicine.snomed_code)}
                  onChange={() => handleServiceRequestCheckboxChange(medicine.snomed_code)}
                />
                <label>{` ${medicine.medicine_name}- ${new Date(medicine.appointment_start_time).toLocaleString()}`}</label>
              </div>
            ))}
          </div> */}
          <h5>Medicines to be Included:</h5>
          <div className="contact-panel mb-50 scrollable-container">
            {medicinesList.map((medicine) => (
              <div key={medicine.snomed_code}>
                <label>{` ${medicine.medicine_name} - ${new Date(medicine.appointment_start_time).toLocaleString()}`}</label>
              </div>
            ))}
          </div>




          {/* <button className="btn btn-primary custom-btn" onClick={handleAddToInvoice}>Add to Invoice</button> */}
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: 0, margin: 0 }}>
        <Button
          onClick={handleAddToInvoice}
          disabled={selectedDoctors.length === 0 && selectedServiceRequests.length === 0 }
          variant="contained"
          color="primary"
          sx={{
            backgroundColor: "#0E3F66",
            borderRadius: "8px",
            fontSize: "20px",
            paddingX: { xs: 2, sm: 3 },
            paddingY: 1,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#0C3555",
            },
          }}
        >
          + {buttonText}
        </Button>
          </div>
          {/* <button className="btn btn-primary custom-btn" onClick={handleAddToInvoice}  disabled={selectedDoctors.length === 0 && selectedServiceRequests.length === 0 }>
            {buttonText}
          </button> */}
        </div>

      </div>

    </div>
  );
};

export default StagingArea;
